import React from 'react';
import { useNavigate } from 'react-router-dom';

import Search, { SearchProps } from 'antd/es/input/Search';

import locationIcon from '@app/images/pin.svg';
import searchIcon from '@app/images/search_white.svg';

interface ComponentProps extends SearchProps {
	icon?: string;
	iconLocation?: boolean;
	widthBorder?: string;
	setSearchActive?: (bool: boolean) => void;
	setSearch?: (value: string) => void;
	searchBody?: string;
	setValue?: (val: string) => void;
	tab?: string;
	autoFocus?: boolean;
	newURLAfterSearch?: boolean;
	searchZipCode?: boolean;
	type?: React.HTMLInputTypeAttribute;
}

const SearchField = React.forwardRef<typeof Search, ComponentProps>((props) => {
	const [checkValidInput, setCheckValidInput] = React.useState<boolean>(true);
	const widthBorder = props.widthBorder || '1';
	const newURLAfterSearch = props.newURLAfterSearch ?? true;
	const searchZipCode = props.searchZipCode ?? true;

	const inputRef: any = React.useRef() as React.RefObject<any>;

	const navigate = useNavigate();

	const enterButton = React.useMemo(() => (
		<button type="submit" className="search-field-button">
			<img src={props.icon || searchIcon} alt="Search Icon" />
		</button>
	), [props.icon]);

	const handleOnSearch = (value) => {
		props.setSearch && props.setSearch(value.trim());
		newURLAfterSearch && navigate(`${props.searchBody || ''}?query=${value.trim()}`);
	};

	React.useEffect(() => {
		if (props.autoFocus) {
			inputRef?.current && inputRef.current?.focus();
		}
	}, [props.autoFocus, props.tab]);

	return (
		<div className="search-field-wrap">
			<Search
				ref={inputRef}
				type={props?.type || 'text'}
				placeholder={props.placeholder || 'Search'}
				className={`search-field search-field--border-${widthBorder} ${checkValidInput ? '' : 'search-field--border-error'}`}
				onSearch={(value) => {
					if (searchZipCode) {
						if (!isNaN(+value) && value.match(/^([0-9]{5})$/)) {
							handleOnSearch(value);
						}
						props.setSearchActive && props.setSearchActive(false);
					} else {
						handleOnSearch(value);
					}
				}}
				style={{ width: 200 }}
				onChange={(e) => {
					if (searchZipCode) {
						if (!isNaN(+e.currentTarget.value) && e.currentTarget.value.match(/^([0-9]{5})$/)) {
							props.setValue && props.setValue(e.currentTarget.value);
							setCheckValidInput(true);
						} else {
							setCheckValidInput(false);
						}
					} else {
						props.setValue && props.setValue(e.currentTarget.value);
						setCheckValidInput(true);
					}
				}}
				enterButton={enterButton}
				value={props.value}
				prefix={props.iconLocation ? <img src={locationIcon} alt="pin" /> : ''}
			/>
		</div>
	);
});

export default SearchField;
